// extracted by mini-css-extract-plugin
export default {"header":"CatalogHeader_header__pabIv","icon":"CatalogHeader_icon__ZGx2W","buttonRight":"CatalogHeader_buttonRight__2jE5z","buttonLeft":"CatalogHeader_buttonLeft__yPBSv"};